export default "__VITE_ASSET__IZtr988Y__"